//
// highlight.js
// Theme module
//

import hljs from 'highlight.js/lib/core';
import xml from 'highlight.js/lib/languages/xml';
import javascript from 'highlight.js/lib/languages/javascript';
import python from 'highlight.js/lib/languages/python';
import bash from 'highlight.js/lib/languages/bash';
import json from 'highlight.js/lib/languages/json';

hljs.registerLanguage('xml', xml);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('python', python);
hljs.registerLanguage('bash', bash);
hljs.registerLanguage('sh', bash);
hljs.registerLanguage('json', json);
hljs.configure({tabReplace: '    '});

export function highlightAll() {
    document.querySelectorAll('pre code.highlight').forEach(el => {
        if (!el.dataset.highlighted) {
            hljs.highlightElement(el);
        }
    });
}

document.addEventListener('DOMContentLoaded', function(){
    setTimeout(highlightAll, 100);
});
